import { type ArrayOrSingle } from "ts-essentials";

export function getArrayOrSingle<T>(value: ArrayOrSingle<T>): T[] {
  if (Array.isArray(value)) {
    return value;
  }
  return [value];
}
